export interface ProductOpinion {
    id: string;
    brand: string;
    model: string;
    ean13: number | string;
    consumer: string;
    wet: string;
    noise: string;
}

export interface ProductOpinionRate {
    id: string;
    value: number;
}

export interface Opinion {
    km: string;
    avg: number;
    marca: string;
    ruido: string;
    confort: string;
    consumo: string;
    mensaje: string;
    relation: string;
    car_model: string;
    agarre_seco: string;
    estabilidad: string;
    agarre_mojado: string;
    avg_int: number;
}

export interface Comment {
    id: number;
    id_market: string;
    created_at: string;
    updated_at: string;
    to_update: boolean;
    id_product: number;
    active: boolean;
    email: string;
    name: string;
    id_culture: string;
    opinion: Opinion;
    banned: string;
    revised: boolean;
    source: string;
    send_mail: boolean;
    send_mail_at?: any;
}

export interface Avg {
    ruido: number;
    confort: number;
    consumo: number;
    relation: number;
    agarre_seco: number;
    estabilidad: number;
    agarre_mojado: number;
    avg: number;
}

export interface ProductOpinionDetail {
    id: number;
    ean13?: any;
    brand: string;
    mrn: string;
    id_b2c: number;
    id_b2b?: any;
    model: string;
    score: number;
    attrs: string;
    opinions: Opinion[];
    avg: Avg;
}

export class ProductOpinionHelper {
    static default(): ProductOpinion {
        return {
            id: null,
            brand: null,
            model: null,
            ean13: null,
            consumer: null,
            wet: null,
            noise: null,
        };
    }

    // static create(obj: Object = {}): ProductRate {
    //     const ini = {
    //         base: ProductRateValuesHelper.create(),
    //         b: ProductRateValuesHelper.create(),
    //         c: ProductRateValuesHelper.create(),
    //         d: ProductRateValuesHelper.create(),
    //     };

    //     return Object.assign(ini, obj);
    // }

    // static fromObject(obj: Object) {
    //     const rate = ProductRateHelper.create();
    //     rate.base = ProductRateValuesHelper.create(obj['base']);
    //     rate.b = ProductRateValuesHelper.create(obj['b']);
    //     rate.c = ProductRateValuesHelper.create(obj['c']);
    //     rate.d = ProductRateValuesHelper.create(obj['d']);
    //     return rate;
    // }
}
